<template>
  <div class="mailHistoryList">
    <mailHistoryList></mailHistoryList>
  </div>
</template>

<script>
import mailHistoryList from './mailHistoryList.vue'

export default {
  components: {
    mailHistoryList
  }
}
</script>
<style scoped>
.mailHistoryList {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/mailHistory/mailHistory.vue